import React from 'react';
import NCNotification from '../../notifications/NCNotification';
import LoadMoreFallback from '../../FeedbackPage/_partials/LoadMoreFallback/LoadMoreFallback';
import { NCNotification as NCNotificationType } from '../../types/nc';
import GenericError from '../../GenericError';
import { type UseFeedResult } from '../hooks';
import s from './NotificationList.scss';

export function getNotificationListDisplayMode({
  isFetching,
  items,
  errorMessage,
  hasMore,
}: UseFeedResult): 'fetching' | 'error' | undefined {
  if (errorMessage) {
    return 'error';
  } else if (isFetching || (items.length === 0 && hasMore)) {
    return 'fetching';
  }
  return undefined;
}

interface Props {
  items: NCNotificationType[];
  displayMode?: 'fetching' | 'error';
  loader?: React.ReactNode;
  onLoadMoreClick?: false | (() => void);
  className?: string;
}

const NotificationList: React.FC<Props> = ({
  items,
  displayMode,
  loader,
  className,
  onLoadMoreClick,
}) => {
  return (
    <div className={className}>
      {items.map(item => (
        <NCNotification key={item.messageId} className={s['notification']} notification={item} />
      ))}
      {displayMode === 'fetching' && loader}
      {displayMode === 'error' && <GenericError />}
      {onLoadMoreClick && <LoadMoreFallback fetchNext={onLoadMoreClick} isActive />}
    </div>
  );
};

NotificationList.displayName = 'NotificationList';

export default NotificationList;
